<template>
  <div class="setting-client-users">
    <div class="toolbar">
      <div class="btns">
        <button type="button" class="btn btn-outline-black w180"
          @click="editItem(-1)">+ New Client User</button>
      </div>

      <div class="filters">
        <div class="input-search">
          <input type="text" name="s" class="form-control" v-model="keyword" placeholder="SEARCH USERS..." @change="getClientUsers()">
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-sm table-hover">
        <thead>
          <tr>
            <th width="40"></th>
            <th width="10%"><a href="javascript:;">FIRST NAME</a></th>
            <th width="10%"><a href="javascript:;">LAST NAME</a></th>
            <th width="20%"><a href="javascript:;">COMPANY</a></th>
            <th><a href="javascript:;">EMAIL</a></th>
            <th width="200"><a href="javascript:;">ACCESS LEVEL</a></th>
            <th width="100"><a href="javascript:;">STATUS</a></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in allMembers" :key="index">
            <td><a href="javascript:;" class="avatar black" @click="editItem(index)">{{ item.initials }}</a></td>
            <td><a href="javascript:;" class="black" @click="editItem(index)">{{ item.first_name }}</a></td>
            <td><a href="javascript:;" class="black" @click="editItem(index)">{{ item.last_name }}</a></td>
            <td><a href="javascript:;" class="black" @click="editItem(index)">{{ item.client.name }}</a></td>
            <td>
              <a :href="'mailto:' + item.email">{{ item.email }}</a>
            </td>
            <td class="text-muted"><a href="javascript:;" class="black" @click="editItem(index)">{{ item.is_manager?'Client Manager':'Client' }}</a></td>
            <td><a href="javascript:;" class="black" @click="editItem(index)">{{ item.enabled?'Active':'Blocked' }}</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="state=='' && hasFilters && totalItems == 0" class="alert alert-warning">
      No users found
    </div>
    <modal-edit-client-user v-model="showModalEdit" :clients="allClients" :item="activeItem" @item-saved="onItemSaved"></modal-edit-client-user>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ServiceClient from '@/services/client'
  import ModalEditClientUser from './ModalEditClientUser';

export default {
  components: {
    ModalEditClientUser,
  },
  data () {
    return {
      state: 'loading',
      keyword: '',
      allClients: [],
      allMembers: [],
      totalItems: 0,
      activeIndex: -1,
      showModalEdit: false
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['CURRENT_USER', 'IS_CLIENT']),
    hasFilters () {
      return this.keyword != '';
    },
    activeItem () {
      let self = this;
      return self.allMembers[self.activeIndex] ? self.allMembers[self.activeIndex] : null;
    }
  },
  created () {},
  mounted () {
    this.init();
  },
  methods: {
    init () {
      let self = this;
      self.getClientUsers();
      self.state = 'loading';
      ServiceClient.getAll({ipp: 'all'}, resp => {
        self.state = '';
        self.allClients = [];
        for (let i in resp) {
          if (!resp[i].is_supplier)
            self.allClients.push(resp[i]);
        }
      });
    },
    editItem ( index ) {
      let self = this;
      self.activeIndex = index;
      self.showModalEdit = true;
    },
    onItemSaved ( item ) {
      let self = this;
      if(self.activeIndex != -1)
        self.allMembers.splice( self.activeIndex, 1, item );
      else
        self.allMembers.push( item );
    },
    getClientUsers () {
      let self = this,
        params = {
          ipp: 'all',
        };

      if (self.keyword !== '') {
        params.kw = self.keyword;
      }
      if (self.IS_CLIENT) {
        params.client_id = self.CURRENT_USER.client_id;
      }
      self.state = 'loading';
      ServiceClient.getAllMembers(params, resp => {
        self.state = '';
        self.allMembers = resp;
        self.totalItems = window.numkeys(self.allMembers);
      });
    }
  }
}
</script>
